var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-introduction"},[_c('div',{staticClass:"left-image",style:({'background-image': 'url('+_vm.introductionData.image+')','width':'100%','height':'100%','background-size':'cover','background-repeat':'no-repeat','background-position':'center'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }